"use strict";
// ===========================================================================
// DO NOT EDIT THIS FILE MANUALLY!
//
// The contents have been added automatically.
// See: scripts/generate-apis.ts for more information
// ===========================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.airnodeAddressMap = exports.apisData = void 0;
exports.apisData = {
    'shiftmarkets-mock': {
        alias: 'shiftmarkets-mock',
        name: 'ShiftMarkets-Mock',
        providerType: 'rest',
        airnode: '0x4C283936141b6AD8253C599091f86DAdE9dd8fDc',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            ShiftMarkets: [
                [
                    'AERO/USD',
                    'BLAST/USD',
                    'ETH/USD',
                    'BTC/USD',
                    'USDT/USD',
                    'CRO/USD',
                    'ONDO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'CORE/USD',
                    'MNT/USD',
                    'OKB/USD',
                    'BNB/USD',
                    'USDC/USD',
                    'SOL/USD',
                    'BAL/USD',
                    'CRV/USD',
                    'DOT/USD',
                    'SHIB/USD',
                    'GLMR/USD',
                    'APE/USD',
                    'LDO/USD',
                    'OP/USD',
                    'GMX/USD',
                    'ARB/USD',
                    'WLD/USD',
                    'FDUSD/USD',
                    'SEI/USD',
                    'DYM/USD',
                    'ETHFI/USD',
                    'KAVA/USD',
                    'AVAX/USD',
                    'AAVE/USD',
                    'GNO/USD',
                    'CVX/USD',
                    'ASTR/USD',
                    'WBTC/USD',
                    'RON/USD',
                    'XRP/USD',
                    'CAKE/USD',
                    'PENDLE/USD',
                    'COMP/USD',
                    'UNI/USD',
                    'GHO/USD',
                    'FRAX/USD',
                    'PAXG/USD',
                    'LQTY/USD',
                    'MANTA/USD',
                    'ENA/USD',
                    'MOVR/USD',
                    'CELO/USD',
                    'API3/USD',
                    'FXS/USD',
                    'TUSD/USD',
                    'TAIKO/USD',
                    'DEGEN/USD',
                    'SAFE/USD',
                    'YFI/USD',
                    'USDP/USD',
                    'stETH/USD',
                    'FBTC/USD',
                    'AUSD/USD',
                    'EURC/USD',
                    'USDe/USD',
                    'LUMIA/USD',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'ZK/USD',
                    'ZRO/USD',
                    'POL/USD',
                    'crvUSD/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'DAI/USD',
                    'INJ/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDD/USD',
                    'EUR/USD',
                    'WELL/USD',
                    'sUSDS/USD',
                    'RLUSD/USD',
                    'USDG/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDf/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'A7A5/USD',
                    'USX/USD',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'AI/USD',
                    'PONS/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    shiftmarkets: {
        alias: 'shiftmarkets',
        name: 'ShiftMarkets',
        providerType: 'rest',
        airnode: '0xB1d60a913C32a5BE249D4fFb4C0229ee20E5590B',
        previousAirnodes: [
            { expiryTimestamp: 1785315782, airnodeAddress: '0x11A49f063c08f9C9d7A6b13E0529dC132Bd09fF5' },
            { expiryTimestamp: 1749546029, airnodeAddress: '0x1538e800Ae1B34C264E3F44B6Cd82bE033f38E20' }
        ],
        xpub: 'xpub6DAhfp3a8DocUGcbQtspNJ1JmpDXqamtX2cXVJX4Ct8KWcRLJGEA5xRGE3fx4oZAFt7TNsUwkFnjL8tSyhFDgPVngcrGQxcaFt5P1QodA4h',
        supportedFeedsInBatches: {
            ShiftMarkets: [
                [
                    'AERO/USD',
                    'BLAST/USD',
                    'ETH/USD',
                    'BTC/USD',
                    'USDT/USD',
                    'CRO/USD',
                    'ONDO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'CORE/USD',
                    'MNT/USD',
                    'OKB/USD',
                    'BNB/USD',
                    'USDC/USD',
                    'SOL/USD',
                    'BAL/USD',
                    'CRV/USD',
                    'DOT/USD',
                    'SHIB/USD',
                    'GLMR/USD',
                    'APE/USD',
                    'LDO/USD',
                    'OP/USD',
                    'GMX/USD',
                    'ARB/USD',
                    'WLD/USD',
                    'FDUSD/USD',
                    'SEI/USD',
                    'DYM/USD',
                    'ETHFI/USD',
                    'KAVA/USD',
                    'AVAX/USD',
                    'AAVE/USD',
                    'GNO/USD',
                    'CVX/USD',
                    'ASTR/USD',
                    'WBTC/USD',
                    'RON/USD',
                    'XRP/USD',
                    'CAKE/USD',
                    'PENDLE/USD',
                    'COMP/USD',
                    'UNI/USD',
                    'GHO/USD',
                    'FRAX/USD',
                    'PAXG/USD',
                    'LQTY/USD',
                    'MANTA/USD',
                    'ENA/USD',
                    'MOVR/USD',
                    'CELO/USD',
                    'API3/USD',
                    'FXS/USD',
                    'TUSD/USD',
                    'TAIKO/USD',
                    'DEGEN/USD',
                    'SAFE/USD',
                    'YFI/USD',
                    'USDP/USD',
                    'stETH/USD',
                    'FBTC/USD',
                    'AUSD/USD',
                    'EURC/USD',
                    'USDe/USD',
                    'LUMIA/USD',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'ZK/USD',
                    'ZRO/USD',
                    'POL/USD',
                    'crvUSD/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'DAI/USD',
                    'INJ/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDD/USD',
                    'EUR/USD',
                    'WELL/USD',
                    'sUSDS/USD',
                    'RLUSD/USD',
                    'USDG/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDf/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'A7A5/USD',
                    'USX/USD',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'AI/USD',
                    'PONS/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-central-1', provider: 'aws' },
            { signedApi: false, region: 'ap-south-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.shiftmarkets.com',
        verifiedBaseUrl: 'https://shiftmarkets.com',
        signedApiUrl: 'https://signed-api.shiftmarkets.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'nodary-mock': {
        alias: 'nodary-mock',
        name: 'Nodary-Mock',
        providerType: 'rest',
        airnode: '0x241364bbd08701330bdc810bAaA10cF8DF1710E5',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Nodary: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sAVAX/AVAX Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'MNT/USD',
                    'KAVA/USD',
                    'GHO/USD',
                    'crvUSD/USD',
                    'FRAX/USD',
                    'USDe/USD',
                    'ASTR/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'stTAO/TAO Exchange Rate',
                    'PYUSD/USD',
                    'MERL/USD',
                    'sFRAX/FRAX Exchange Rate',
                    'INJ/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'EURC/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'wBETH/ETH Exchange Rate',
                    'BNBx/BNB Exchange Rate',
                    'slisBNB/BNB Exchange Rate',
                    'TAIKO/USD',
                    'BLAST/USD',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'POL/USD',
                    'eBTC/WBTC Exchange Rate',
                    'AUSD/USD',
                    'FBTC/USD',
                    'LUMIA/USD',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'MORPHO/USD',
                    'yUSD/USD Exchange Rate',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'S/USD',
                    'VELO/USD',
                    'scrvUSD/crvUSD Exchange Rate',
                    'BERA/USD',
                    'sUSDS/USDS Exchange Rate',
                    'USDS/USD',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'HYPE/USD',
                    'tBTC/USD',
                    'frxUSD/USD',
                    'VIRTUAL/USD',
                    'osETH/ETH Exchange Rate',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'EUR/USD',
                    'WELL/USD',
                    'wOS/OS Exchange Rate',
                    'USD1/USD',
                    'ATH/USD',
                    'syrupUSDC/USDC Exchange Rate',
                    'SOMI/USD',
                    'wsrUSD/rUSD Exchange Rate',
                    'SKY/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'tETH/wstETH Exchange Rate',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'siUSD/iUSD Exchange Rate',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'USDG/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'PONS/USD',
                    'AI/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    nodary: {
        alias: 'nodary',
        name: 'Nodary',
        providerType: 'rest',
        airnode: '0xc52EeA00154B4fF1EbbF8Ba39FDe37F1AC3B9Fd4',
        previousAirnodes: [],
        xpub: 'xpub6Cd14fbNsTqhi7Urd3cyXHD1nfpDyFf2b5jLcNcwtcEiGzJpQ9UNDwNinYCEmoXgCEZyMZYmAPCaGCFBuCqMD8Pkz8zXWt4rgre8kQLFUMA',
        supportedFeedsInBatches: {
            Nodary: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sAVAX/AVAX Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'MNT/USD',
                    'KAVA/USD',
                    'GHO/USD',
                    'crvUSD/USD',
                    'FRAX/USD',
                    'USDe/USD',
                    'ASTR/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'stTAO/TAO Exchange Rate',
                    'PYUSD/USD',
                    'MERL/USD',
                    'sFRAX/FRAX Exchange Rate',
                    'INJ/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'EURC/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'wBETH/ETH Exchange Rate',
                    'BNBx/BNB Exchange Rate',
                    'slisBNB/BNB Exchange Rate',
                    'TAIKO/USD',
                    'BLAST/USD',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'POL/USD',
                    'eBTC/WBTC Exchange Rate',
                    'AUSD/USD',
                    'FBTC/USD',
                    'LUMIA/USD',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'MORPHO/USD',
                    'yUSD/USD Exchange Rate',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'S/USD',
                    'VELO/USD',
                    'scrvUSD/crvUSD Exchange Rate',
                    'BERA/USD',
                    'sUSDS/USDS Exchange Rate',
                    'USDS/USD',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'HYPE/USD',
                    'tBTC/USD',
                    'frxUSD/USD',
                    'VIRTUAL/USD',
                    'osETH/ETH Exchange Rate',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'EUR/USD',
                    'WELL/USD',
                    'wOS/OS Exchange Rate',
                    'USD1/USD',
                    'ATH/USD',
                    'syrupUSDC/USDC Exchange Rate',
                    'SOMI/USD',
                    'wsrUSD/rUSD Exchange Rate',
                    'SKY/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'tETH/wstETH Exchange Rate',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'siUSD/iUSD Exchange Rate',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'USDG/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'PONS/USD',
                    'AI/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: false, region: 'eu-north-1', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://nodary.io',
        verifiedBaseUrl: 'https://nodary.io',
        signedApiUrl: 'https://signed-api.nodary.io',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'ncfx-mock': {
        alias: 'ncfx-mock',
        name: 'NCFX-Mock',
        providerType: 'rest',
        airnode: '0x220Ad4917B349F69288E892e50E929A693B71920',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            'NewChangeFX-Crypto': [
                [
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'KAVA/USD',
                    'MNT/USD',
                    'ASTR/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'PYUSD/USD',
                    'INJ/USD',
                    'DEGEN/USD',
                    'CORE/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'SAFE/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'EURC/USD',
                    'MERL/USD',
                    'TAIKO/USD',
                    'USDe/USD',
                    'BRETT/USD',
                    'LUMIA/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'POL/USD',
                    'HYPE/USD',
                    'ETHFI/USD',
                    'ENA/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'TRX/USD',
                    'VVV/USD',
                    'U/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'ZEC/USD',
                    'AI/USD',
                    'PONS/USD',
                    'NPC/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    ncfx: {
        alias: 'ncfx',
        name: 'NCFX',
        providerType: 'rest',
        airnode: '0x68ec391b38A66A4B19543dc031f2659e2224a781',
        previousAirnodes: [
            { expiryTimestamp: 1785738567, airnodeAddress: '0x03d932A39Ee94F1D5Fdf3434f8ca651E5Dc479D0' },
            { expiryTimestamp: 1776752531, airnodeAddress: '0xbC6471E88d8aFe936A45bEB8bd20a210EBEF6822' }
        ],
        xpub: 'xpub6CdvH1SoiMB4mQZVnPgDPBzNDh4u34cB9Saws3jnaVmKDsRRnNnbTrppdd4scpaJYYwsjoEprADEszAmyEEfLtFZGkhi6f9yqZ8TGRn5PGB',
        supportedFeedsInBatches: {
            'NewChangeFX-Crypto': [
                [
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'KAVA/USD',
                    'MNT/USD',
                    'ASTR/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'PYUSD/USD',
                    'INJ/USD',
                    'DEGEN/USD',
                    'CORE/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'SAFE/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'EURC/USD',
                    'MERL/USD',
                    'TAIKO/USD',
                    'USDe/USD',
                    'BRETT/USD',
                    'LUMIA/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'POL/USD',
                    'HYPE/USD',
                    'ETHFI/USD',
                    'ENA/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'TRX/USD',
                    'VVV/USD',
                    'U/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'ZEC/USD',
                    'AI/USD',
                    'PONS/USD',
                    'NPC/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-west-2', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.newchangefx.com',
        verifiedBaseUrl: 'https://newchangefx.com',
        signedApiUrl: 'https://signed-api.newchangefx.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'infura-mock': {
        alias: 'infura-mock',
        name: 'Infura-Mock',
        providerType: 'rpc',
        airnode: '0x4D81964F58409651eF5C191166a9Ff6e6b40986f',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Infura: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate',
                    'syrupUSDC/USDC Exchange Rate',
                    'wsrUSD/rUSD Exchange Rate',
                    'tETH/wstETH Exchange Rate',
                    'siUSD/iUSD Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    infura: {
        alias: 'infura',
        name: 'Infura',
        providerType: 'rpc',
        airnode: '0xb43698033233427a21AA1f0863c5C2852b6C8b5E',
        previousAirnodes: [
            { expiryTimestamp: 1785140581, airnodeAddress: '0x6B0Cf14Be1766fE17566C5295462E21B288071A8' },
            { expiryTimestamp: 1776667371, airnodeAddress: '0x72bFf91fc62E03f917D5c1202225f92f74cBe67e' }
        ],
        xpub: 'xpub6By3sfbhRhGj8Z99jEpCvwJnRK1E8jwNQk7ESHCky6H79UFupm4v8EVwVwAvm7GVhej3EWywKNxDNi11L13owzmqw26MpMBBpBafzn4Ee5P',
        supportedFeedsInBatches: {
            Infura: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate',
                    'syrupUSDC/USDC Exchange Rate',
                    'wsrUSD/rUSD Exchange Rate',
                    'tETH/wstETH Exchange Rate',
                    'siUSD/iUSD Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-1', provider: 'aws' },
            { signedApi: false, region: 'eu-west-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.infura.io',
        verifiedBaseUrl: 'https://infura.io',
        signedApiUrl: 'https://signed-api.infura.io',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'drpc-mock': {
        alias: 'drpc-mock',
        name: 'dRPC-Mock',
        providerType: 'rpc',
        airnode: '0xDFCC177437f9Be5e5A0828A620664A4C1321e780',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            dRPC: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate',
                    'syrupUSDC/USDC Exchange Rate',
                    'wsrUSD/rUSD Exchange Rate',
                    'tETH/wstETH Exchange Rate',
                    'siUSD/iUSD Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    drpc: {
        alias: 'drpc',
        name: 'dRPC',
        providerType: 'rpc',
        airnode: '0x25cFD221A462076a25e6df9932C7D669b455941E',
        previousAirnodes: [
            { expiryTimestamp: 1785738303, airnodeAddress: '0xA663F3C3FCF8aaA9A2196F5Be2510A5717748D57' },
            { expiryTimestamp: 1758614051, airnodeAddress: '0x14F4bC1EC875f4A8d260721B0A7b07262A71a220' }
        ],
        xpub: 'xpub6DDR6HUfdFMa5BQQQSWHBMNUnBcx5xYTioBoH3LEFv1Vr7WyuoyfiPsDhJRuZYJ95rQutNhJHigXYS8BDtmW4p7nBrqF8bRAazkN4n2U63r',
        supportedFeedsInBatches: {
            dRPC: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate',
                    'syrupUSDC/USDC Exchange Rate',
                    'wsrUSD/rUSD Exchange Rate',
                    'tETH/wstETH Exchange Rate',
                    'siUSD/iUSD Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-2', provider: 'aws' },
            { signedApi: false, region: 'eu-central-1', provider: 'aws' }
        ],
        homepageUrl: 'https://drpc.org',
        verifiedBaseUrl: 'https://drpc.org',
        signedApiUrl: 'https://signed-api.drpc.org',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'coinpaprika-mock': {
        alias: 'coinpaprika-mock',
        name: 'CoinPaprika-Mock',
        providerType: 'rest',
        airnode: '0x59493508C6CdE2179100CE2994919Dae38D893b2',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Coinpaprika: [
                [
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'FRAX/USD',
                    'crvUSD/USD',
                    'GHO/USD',
                    'MNT/USD',
                    'KAVA/USD',
                    'USDe/USD',
                    'ASTR/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'INJ/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'EURC/USD',
                    'POL/USD',
                    'AUSD/USD',
                    'FBTC/USD',
                    'LUMIA/USD',
                    'BRETT/USD',
                    'cbBTC/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDf/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'A7A5/USD',
                    'USX/USD',
                    'KAG/USD',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'U/USD',
                    'USDGO/USD',
                    'APXUSD/USD',
                    'REUSD/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'PONS/USD',
                    'AI/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    coinpaprika: {
        alias: 'coinpaprika',
        name: 'CoinPaprika',
        providerType: 'rest',
        airnode: '0xE79B702c477127c18A0e1b47Fb008b725035c826',
        previousAirnodes: [
            { expiryTimestamp: 1783493451, airnodeAddress: '0x8131738b22aE987991c3C99a43e119456880B8eF' },
            { expiryTimestamp: 1765260845, airnodeAddress: '0xC9B494D3c6eA3fD42779Df9A136Db10374c98D80' }
        ],
        xpub: 'xpub6D652gzaJC4MVtMhAuLEjGMAiL1U4LwC95u2m8EmGSs1mV1mRVcgbVnmuYWT3UoH9PDPea7KRdEvjJaahUhXfx83Pf86kenVpRw7WX5vdL7',
        supportedFeedsInBatches: {
            Coinpaprika: [
                [
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'FRAX/USD',
                    'crvUSD/USD',
                    'GHO/USD',
                    'MNT/USD',
                    'KAVA/USD',
                    'USDe/USD',
                    'ASTR/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'INJ/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'EURC/USD',
                    'POL/USD',
                    'AUSD/USD',
                    'FBTC/USD',
                    'LUMIA/USD',
                    'BRETT/USD',
                    'cbBTC/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDf/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'A7A5/USD',
                    'USX/USD',
                    'KAG/USD',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'U/USD',
                    'USDGO/USD',
                    'APXUSD/USD',
                    'REUSD/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'PONS/USD',
                    'AI/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-1', provider: 'aws' },
            { signedApi: false, region: 'eu-north-1', provider: 'aws' }
        ],
        homepageUrl: 'https://coinpaprika.com',
        verifiedBaseUrl: 'https://coinpaprika.com',
        signedApiUrl: 'https://signed-api.coinpaprika.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'coinmetrics-mock': {
        alias: 'coinmetrics-mock',
        name: 'Coin Metrics-Mock',
        providerType: 'rest',
        airnode: '0xdc34ada68055EEa2221DdafaF4bcBB8ddBD6CC7d',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            CoinMetrics: [
                [
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'FRAX/USD',
                    'crvUSD/USD',
                    'GHO/USD',
                    'MNT/USD',
                    'ASTR/USD',
                    'KAVA/USD',
                    'DYM/USD',
                    'USDe/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'INJ/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'POL/USD',
                    'EURC/USD',
                    'AUSD/USD',
                    'LUMIA/USD',
                    'BRETT/USD',
                    'cbBTC/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'KSM/USD',
                    'USDf/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'CLO/USD',
                    'FBTC/USD',
                    'frxUSD/USD',
                    'BFUSD/USD',
                    'TRX/USD',
                    'VVV/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'AI/USD',
                    'PONS/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    coinmetrics: {
        alias: 'coinmetrics',
        name: 'Coin Metrics',
        providerType: 'rest',
        airnode: '0x2D652E95524c4b6D09FA149F66e2168222cd27a5',
        previousAirnodes: [{ expiryTimestamp: 1783320907, airnodeAddress: '0xF871fb16191352E5Ad43183a996a9AA9Fd0d933b' }],
        xpub: 'xpub6C4fQfF3umtP4g2K3ULD9HiSAn1QygY4CNiyb72R8UZeaeyXFc7B1LHCYhLXT2ksMV8XrrEDs5Ts2VLxLMBGWhJveTVa2S9RVgNeU1ze1wA',
        supportedFeedsInBatches: {
            CoinMetrics: [
                [
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'FRAX/USD',
                    'crvUSD/USD',
                    'GHO/USD',
                    'MNT/USD',
                    'ASTR/USD',
                    'KAVA/USD',
                    'DYM/USD',
                    'USDe/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'INJ/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'POL/USD',
                    'EURC/USD',
                    'AUSD/USD',
                    'LUMIA/USD',
                    'BRETT/USD',
                    'cbBTC/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'KSM/USD',
                    'USDf/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'CLO/USD',
                    'FBTC/USD',
                    'frxUSD/USD',
                    'BFUSD/USD',
                    'TRX/USD',
                    'VVV/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'AI/USD',
                    'PONS/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-2', provider: 'aws' },
            { signedApi: false, region: 'eu-west-2', provider: 'aws' }
        ],
        homepageUrl: 'https://coinmetrics.io',
        verifiedBaseUrl: 'https://api.coinmetrics.io',
        signedApiUrl: 'https://signed-api.coinmetrics.io',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'coingecko-mock': {
        alias: 'coingecko-mock',
        name: 'CoinGecko-Mock',
        providerType: 'rest',
        airnode: '0x887cA5E7D4d6CcE427949561CD149983F39c9F02',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            CoinGecko: [
                [
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'FRAX/USD',
                    'crvUSD/USD',
                    'GHO/USD',
                    'MNT/USD',
                    'ASTR/USD',
                    'KAVA/USD',
                    'DYM/USD',
                    'USDe/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'INJ/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'POL/USD',
                    'EURC/USD',
                    'FBTC/USD',
                    'AUSD/USD',
                    'LUMIA/USD',
                    'BRETT/USD',
                    'cbBTC/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'sUSDS/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDf/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'A7A5/USD',
                    'KAU/USD',
                    'USX/USD',
                    'KAG/USD',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'U/USD',
                    'USDGO/USD',
                    'YLDS/USD',
                    'APXUSD/USD',
                    'SOFID/USD',
                    'REUSD/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'PONS/USD',
                    'AI/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    coingecko: {
        alias: 'coingecko',
        name: 'CoinGecko',
        providerType: 'rest',
        airnode: '0x9dB03a07bE313B3C08261B1d1606D511f3560D9e',
        previousAirnodes: [
            { expiryTimestamp: 1783404244, airnodeAddress: '0xf19572194e6aD6d84666906D5287e2c9427655C2' },
            { expiryTimestamp: 1765170744, airnodeAddress: '0x6b56E47DccFbC82D63Df3da417d26e8B1B877f0f' }
        ],
        xpub: 'xpub6BvxhiAekuJKJvVToWpb99YkNDFokPm2CdxBBJvNuEXJ8VMAnKiDNDaSAmSeDq3Mc8hrV6qvoyqMnni5WMDcRdkqi9fMWZ1wZ5J6YQHf3Fy',
        supportedFeedsInBatches: {
            CoinGecko: [
                [
                    'AAVE/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOT/USD',
                    'ETH/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'FRAX/USD',
                    'crvUSD/USD',
                    'GHO/USD',
                    'MNT/USD',
                    'ASTR/USD',
                    'KAVA/USD',
                    'DYM/USD',
                    'USDe/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'PENDLE/USD',
                    'AERO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'INJ/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'POL/USD',
                    'EURC/USD',
                    'FBTC/USD',
                    'AUSD/USD',
                    'LUMIA/USD',
                    'BRETT/USD',
                    'cbBTC/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'sUSDS/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDf/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'A7A5/USD',
                    'KAU/USD',
                    'USX/USD',
                    'KAG/USD',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'U/USD',
                    'USDGO/USD',
                    'YLDS/USD',
                    'APXUSD/USD',
                    'SOFID/USD',
                    'REUSD/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'PONS/USD',
                    'AI/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-2', provider: 'aws' },
            { signedApi: false, region: 'eu-west-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.coingecko.com',
        verifiedBaseUrl: 'https://www.coingecko.com',
        signedApiUrl: 'https://signed-api.coingecko.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'blocksize-mock': {
        alias: 'blocksize-mock',
        name: 'BLOCKSIZE-Mock',
        providerType: 'rest',
        airnode: '0x3E377AcDc90AD2912E92B5031aAE4BBFb3670b95',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Blocksize: [
                [
                    'AAVE/USD',
                    'AERO/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'ASTR/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BLAST/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'CORE/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DOT/USD',
                    'ENA/USD',
                    'ETH/USD',
                    'ETHFI/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'INJ/USD',
                    'KAVA/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MANTA/USD',
                    'MERL/USD',
                    'MNT/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'RON/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TAIKO/USD',
                    'UNI/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'DEGEN/USD',
                    'DYM/USD',
                    'SAFE/USD',
                    'WLD/USD',
                    'PENDLE/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'DAI/USD',
                    'POL/USD',
                    'TUSD/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'USDT/USD',
                    'GHO/USD',
                    'crvUSD/USD',
                    'FRAX/USD',
                    'AUSD/USD',
                    'EURC/USD',
                    'USDe/USD',
                    'FBTC/USD',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'LUMIA/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'ZK/USD',
                    'ZRO/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'sUSDS/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDf/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'EUR/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'A7A5/USD',
                    'USX/USD',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'U/USD',
                    'REUSD/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'AI/USD',
                    'PONS/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    blocksize: {
        alias: 'blocksize',
        name: 'BLOCKSIZE',
        providerType: 'rest',
        airnode: '0xBA910Eb2867977A0a651FE3D2607237ff4116B1C',
        previousAirnodes: [
            { expiryTimestamp: 1780472785, airnodeAddress: '0xabfbeE00151A4Dc99548341F2e3e75f7abB37B61' },
            { expiryTimestamp: 1749628891, airnodeAddress: '0x1Fb13E33B505d359b734F02A95E392284A205895' }
        ],
        xpub: 'xpub6C9C823p1aK3JJD36mQ3vAGLEwFWPjvqoJY1Q5dzi2dSvjpQpByhSc393wWoKMnRxEKSnhoAQYh4rx6bfUarohASvrR5KouCRv59Zsnj2Eh',
        supportedFeedsInBatches: {
            Blocksize: [
                [
                    'AAVE/USD',
                    'AERO/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'ASTR/USD',
                    'AVAX/USD',
                    'BAL/USD',
                    'BLAST/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'CORE/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DOT/USD',
                    'ENA/USD',
                    'ETH/USD',
                    'ETHFI/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'INJ/USD',
                    'KAVA/USD',
                    'LDO/USD',
                    'LQTY/USD',
                    'MANTA/USD',
                    'MERL/USD',
                    'MNT/USD',
                    'MOVR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'RON/USD',
                    'SHIB/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'TAIKO/USD',
                    'UNI/USD',
                    'WBTC/USD',
                    'XRP/USD',
                    'YFI/USD',
                    'DEGEN/USD',
                    'DYM/USD',
                    'SAFE/USD',
                    'WLD/USD',
                    'PENDLE/USD',
                    'SEI/USD',
                    'ONDO/USD',
                    'DAI/USD',
                    'POL/USD',
                    'TUSD/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'USDT/USD',
                    'GHO/USD',
                    'crvUSD/USD',
                    'FRAX/USD',
                    'AUSD/USD',
                    'EURC/USD',
                    'USDe/USD',
                    'FBTC/USD',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'LUMIA/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'ZK/USD',
                    'ZRO/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'tBTC/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'sUSDS/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDf/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'EUR/USD',
                    'WELL/USD',
                    'ATH/USD',
                    'SKY/USD',
                    'SOMI/USD',
                    'LINEA/USD',
                    'ZKC/USD',
                    'CLO/USD',
                    'KSM/USD',
                    'FLUID/USD',
                    'PEPE/USD',
                    'Mog/USD',
                    'FLOKI/USD',
                    'SPX/USD',
                    'AXS/USD',
                    'EIGEN/USD',
                    'BFUSD/USD',
                    'A7A5/USD',
                    'USX/USD',
                    'TRX/USD',
                    'CASHCAT/USD',
                    'VVV/USD',
                    'U/USD',
                    'REUSD/USD',
                    'USAT/USD',
                    'EURCV/USD',
                    'DOGE/USD',
                    'ADA/USD',
                    'LTC/USD',
                    'NPC/USD',
                    'ZEC/USD',
                    'AI/USD',
                    'PONS/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-central-1', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.blocksize.info',
        verifiedBaseUrl: 'https://blocksize.info',
        signedApiUrl: 'https://signed-api.blocksize.info',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'ankr-mock': {
        alias: 'ankr-mock',
        name: 'Ankr-Mock',
        providerType: 'rpc',
        airnode: '0x2eBAe534e166b3D940a53511aD479C3e1de2A1af',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Ankr: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate',
                    'syrupUSDC/USDC Exchange Rate',
                    'wsrUSD/rUSD Exchange Rate',
                    'tETH/wstETH Exchange Rate',
                    'siUSD/iUSD Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    ankr: {
        alias: 'ankr',
        name: 'Ankr',
        providerType: 'rpc',
        airnode: '0x780e6b470bA996fA1eb6FcCfE8EB64F6208a55fa',
        previousAirnodes: [
            { expiryTimestamp: 1780307587, airnodeAddress: '0xD4e37ce12078DC4e7abDB7D470Eab5278FC31492' },
            { expiryTimestamp: 1758716112, airnodeAddress: '0xAaA5fdF8189C6344bA17De6C1a877beb416990AC' }
        ],
        xpub: 'xpub6BxQSFDxxfmfnLQTwAWRanviaorB34mtTb4CSo7d2sBLa6pCg3XmYYVT9zifbDgPjmxh9dQwDKXehcvqkRozewKxTiDLnAyVCRuNpzs4xZn',
        supportedFeedsInBatches: {
            Ankr: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate',
                    'syrupUSDC/USDC Exchange Rate',
                    'wsrUSD/rUSD Exchange Rate',
                    'tETH/wstETH Exchange Rate',
                    'siUSD/iUSD Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-1', provider: 'aws' },
            { signedApi: false, region: 'eu-central-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.ankr.com',
        verifiedBaseUrl: 'ankr.com',
        signedApiUrl: 'https://signed-api.ankr.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'alchemy-mock': {
        alias: 'alchemy-mock',
        name: 'Alchemy-Mock',
        providerType: 'rpc',
        airnode: '0x5B2a49765b8E5820E3642c2C21a997A7D02BbcAC',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Alchemy: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate',
                    'syrupUSDC/USDC Exchange Rate',
                    'wsrUSD/rUSD Exchange Rate',
                    'tETH/wstETH Exchange Rate',
                    'siUSD/iUSD Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    alchemy: {
        alias: 'alchemy',
        name: 'Alchemy',
        providerType: 'rpc',
        airnode: '0x7fE93423D08b5e55000d7762F47f80e07A8F389c',
        previousAirnodes: [
            { expiryTimestamp: 1780387900, airnodeAddress: '0x4DC137F7A90EB83774D644fdb756ea0Ddbbaf368' },
            { expiryTimestamp: 1758522181, airnodeAddress: '0x886AD79b463B1BCa97C0fbF4D5e9782542e5EE40' }
        ],
        xpub: 'xpub6CpYtYajNM2egwf1FapA77nbLLysBaJKj3F1xmN5HjVprAAjVEvaZCRmzKJ4N29Wvo4iDcpx9dejnMj3nhY7mdYS1WHdWhchwLWtKNp36Pg',
        supportedFeedsInBatches: {
            Alchemy: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate',
                    'syrupUSDC/USDC Exchange Rate',
                    'wsrUSD/rUSD Exchange Rate',
                    'tETH/wstETH Exchange Rate',
                    'siUSD/iUSD Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-central-1', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.alchemy.com',
        verifiedBaseUrl: 'https://alchemy.com',
        signedApiUrl: 'https://signed-api.alchemy.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    }
};
exports.airnodeAddressMap = {
    'shiftmarkets-mock': '0x4C283936141b6AD8253C599091f86DAdE9dd8fDc',
    shiftmarkets: '0xB1d60a913C32a5BE249D4fFb4C0229ee20E5590B',
    'nodary-mock': '0x241364bbd08701330bdc810bAaA10cF8DF1710E5',
    nodary: '0xc52EeA00154B4fF1EbbF8Ba39FDe37F1AC3B9Fd4',
    'ncfx-mock': '0x220Ad4917B349F69288E892e50E929A693B71920',
    ncfx: '0x68ec391b38A66A4B19543dc031f2659e2224a781',
    'infura-mock': '0x4D81964F58409651eF5C191166a9Ff6e6b40986f',
    infura: '0xb43698033233427a21AA1f0863c5C2852b6C8b5E',
    'drpc-mock': '0xDFCC177437f9Be5e5A0828A620664A4C1321e780',
    drpc: '0x25cFD221A462076a25e6df9932C7D669b455941E',
    'coinpaprika-mock': '0x59493508C6CdE2179100CE2994919Dae38D893b2',
    coinpaprika: '0xE79B702c477127c18A0e1b47Fb008b725035c826',
    'coinmetrics-mock': '0xdc34ada68055EEa2221DdafaF4bcBB8ddBD6CC7d',
    coinmetrics: '0x2D652E95524c4b6D09FA149F66e2168222cd27a5',
    'coingecko-mock': '0x887cA5E7D4d6CcE427949561CD149983F39c9F02',
    coingecko: '0x9dB03a07bE313B3C08261B1d1606D511f3560D9e',
    'blocksize-mock': '0x3E377AcDc90AD2912E92B5031aAE4BBFb3670b95',
    blocksize: '0xBA910Eb2867977A0a651FE3D2607237ff4116B1C',
    'ankr-mock': '0x2eBAe534e166b3D940a53511aD479C3e1de2A1af',
    ankr: '0x780e6b470bA996fA1eb6FcCfE8EB64F6208a55fa',
    'alchemy-mock': '0x5B2a49765b8E5820E3642c2C21a997A7D02BbcAC',
    alchemy: '0x7fE93423D08b5e55000d7762F47f80e07A8F389c'
};
//# sourceMappingURL=apis.js.map